export default __webpack_public_path__ + "static/media/ekincare_logo.002cdfcc.svg";